import { type FeatureFlagNames, type FeatureFlags } from 'api/getFeatureFlags';
import { addQueryString } from './url';

export const isFeatureFlagEnabled = (pin: FeatureFlagNames, flags?: FeatureFlags): boolean => {
  const flagToggle = flags?.toggles.find((toggle) => toggle.name === pin);

  if (flagToggle) {
    return flagToggle.enabled;
  }

  return false;
};

export const getActiveFeatureFlags = (flags?: FeatureFlags): ReadonlyArray<string> => {
  return flags?.toggles.filter((t) => t.enabled).map((t) => t.name) ?? [];
};

export const addVariantParam = (url: string, featureFlags: FeatureFlags) => {
  const useABGroupA = isFeatureFlagEnabled('ft_ab_group_a', featureFlags);
  const useABGroupB = isFeatureFlagEnabled('ft_ab_group_b', featureFlags);
  const useABGroupC = isFeatureFlagEnabled('ft_ab_group_c', featureFlags);

  if (useABGroupA) {
    return addQueryString(url, 'variant=a');
  }

  if (useABGroupB) {
    return addQueryString(url, 'variant=b');
  }

  if (useABGroupC) {
    return addQueryString(url, 'variant=c');
  }

  return url;
};
